module.exports = "js/webpack/912ec66d7572ff821749319396470bde.svg";